import PublicServiceDescription from '../components/PublicServiceDescription/PublicPage'

export default [
    {
        path: '/service/:alias',
        name: 'public-service-description',
        component: PublicServiceDescription,
        props: true
    },
]
